import React, { useState, useEffect } from 'react';
import { WHAT_IM_BUILDING } from '../data';

function LiveMetric({ label, value, delay }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), delay); return () => clearTimeout(t); }, [delay]);
  return (
    <div style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.5s ease', textAlign: 'center' }}>
      <div style={{ fontFamily: 'var(--font-display)', fontSize: '28px', fontWeight: 600, color: '#fafaf8', lineHeight: 1, marginBottom: '4px' }}>{value}</div>
      <div style={{ fontFamily: 'var(--font-mono)', fontSize: '9px', letterSpacing: '0.2em', color: 'rgba(250,250,248,0.4)', textTransform: 'uppercase' }}>{label}</div>
    </div>
  );
}

export default function WhatImBuilding() {
  useEffect(() => { const i = setInterval(() => {}, 3000); return () => clearInterval(i); }, []);

  return (
    // Fixed dark background — does not shift with mood variables
    <section style={{ padding: '80px 0', background: '#1a1a1a', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
      <div style={{ padding: '0 12%' }}>
        <div className="fade-in" style={{ marginBottom: '48px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '16px' }}>
          <div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: '11px', letterSpacing: '0.28em', color: 'rgba(250,250,248,0.35)', textTransform: 'uppercase', marginBottom: '12px' }}>
              Live · What I'm Building
            </div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: 600, color: '#fafaf8', lineHeight: 1, letterSpacing: '-0.03em' }}>Active Ventures</h2>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontFamily: 'var(--font-mono)', fontSize: '9px', letterSpacing: '0.2em', color: 'rgba(250,250,248,0.3)', textTransform: 'uppercase' }}>
            <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 6px rgba(34,197,94,0.6)', display: 'inline-block', animation: 'pulse 2s infinite' }} />
            Building in public
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1px' }}>
          {WHAT_IM_BUILDING.map((item, i) => (
            <div key={i} style={{ border: '1px solid rgba(250,250,248,0.08)', padding: '36px', position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, width: '3px', height: '100%', background: item.color }} />
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: '9px', letterSpacing: '0.2em', color: 'rgba(250,250,248,0.3)', textTransform: 'uppercase', marginBottom: '12px' }}>
                <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#22c55e', display: 'inline-block', marginRight: '8px', boxShadow: '0 0 4px rgba(34,197,94,0.5)' }} />
                Active
              </div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: '28px', fontWeight: 600, color: '#fafaf8', marginBottom: '6px', letterSpacing: '-0.02em' }}>{item.name}</div>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '13px', color: 'rgba(250,250,248,0.45)', fontWeight: 300, marginBottom: '32px' }}>{item.description}</div>
              <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                {item.metrics.map((m, j) => (
                  <LiveMetric key={j} label={m.label} value={m.value} delay={i * 200 + j * 100} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }`}</style>
    </section>
  );
}
